import { render } from "./SectionTwenty.vue?vue&type=template&id=8ad94056"
import script from "./SectionTwenty.vue?vue&type=script&lang=js"
export * from "./SectionTwenty.vue?vue&type=script&lang=js"

import "./SectionTwenty.vue?vue&type=style&index=0&id=8ad94056&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__